import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 67AF0ACC-DE69-4E39-8226-B913764EAFE5
 * name file-document-alert
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-document-alert.svg
 * tags
 * - Files / Folders 
 * - Alert / Error 
 */
export const FileDocumentAlertIcon = createSvgIcon(<><path d="M20 17H22V15H20V17M20 7V13H22V7H20M11 9H16.5L11 3.5V9M4 2H12L18 8V20C18 21.11 17.11 22 16 22H4C2.89 22 2 21.1 2 20V4C2 2.89 2.89 2 4 2M13 18V16H4V18H13M16 14V12H4V14H16Z" /></>, 'FileDocumentAlertIcon');
export default FileDocumentAlertIcon